import type { TermDocument } from "../@types/services/TermDocument";
import { api } from "./api";

type TermDocumentForm = {
  attachment_en: string;
  attachment_pt_br: string;
  justification?: string;
  term_id: string;
};

const API_BASE_URL = "/api/v3/term_documents";

export const fetchTermDocument = async (id: string): Promise<TermDocument> => {
  const response = await api.get<TermDocument>(`/${id}`, {
    baseURL: API_BASE_URL,
  });

  return response.data;
};

export const addAttachment = async (
  termDocumentId: string,
  attachmentPtBr: File,
  attachmentEn: File,
): Promise<void> => {
  const formData = new FormData();
  formData.append("attachment_pt_br", attachmentPtBr);
  formData.append("attachment_en", attachmentEn);

  await api.post<TermDocument>(`/${termDocumentId}/add_attachment`, formData, {
    baseURL: API_BASE_URL,
    headers: {
      "content-type": "multipart/form-data",
    },
  });
};

export const createTermDocument = async (
  data: TermDocumentForm,
  // attachmentPtBr: File,
  // attachmentEn: File,
): Promise<TermDocument> => {
  const response = await api.post<TermDocument>("", data, {
    baseURL: API_BASE_URL,
  });

  // await addAttachment(response.data.id, attachmentPtBr, attachmentEn);

  return response.data;
};
